import { Component, OnInit } from '@angular/core';
import { TransmitService } from 'src/app/core/services/transmit.service';

@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
    standalone: false
})
export class ErrorPageComponent implements OnInit {

  constructor(private transmit: TransmitService) { }

  ngOnInit(): void {
    this.transmit.emit('no-sideBar', true);
  }

}
